export const getHttpMethod = (id: string, isClone?: boolean): 'put' | 'post' => {
  if (isClone) return 'post';
  if (id === 'create') return 'post';

  if (id) return 'put';
  return 'post';
};
